<template>
  <input type="range" :value="opacityValue" :min="minOpacity" :max="maxOpacity" @input="updateValue($event)"
    class="map-layer-opacity-slider" />
  <div class="slider-progress" :style="{ width: progressWidth }"></div>
</template>

<script>
export default {
  name: 'MapLayerOpacitySlider',
  props: {
    opacityValue: {
      type: Number,
      default: 1,
    },
    minOpacity: {
      type: Number,
      default: 0,
    },
    maxOpacity: {
      type: Number,
      default: 1,
    },
  },
  emits: ['update:opacityValue'],
  setup(props, { emit }) {
    const updateValue = (event) => {
      emit('update:opacityValue', parseFloat(event.target.value))
    };

    return {
      updateValue,
    };
  },
  computed: {
    progressWidth() {
      try {
        const ratio = (this.opacityValue - this.minOpacity) / (this.maxOpacity - this.minOpacity)
        return `calc(${ratio * 100}% - (${ratio} * 30px))`
      } catch (error) { /* empty */ }
      return `0%`
    },
  },
};
</script>

<style scoped>
.map-layer-opacity-slider {
  width: 9em;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: #ccc;
  border-radius: 15px;
  outline: none;
  z-index: 1;
  position: absolute;
  top: 40%;
  left: 0.5em;
}

.map-layer-opacity-slider::-webkit-slider-runnable-track {
  width: 100%;
  height: 5px;
  background: #ccc;
  border: none;
  border-radius: 3px;
}

.map-layer-opacity-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  border: none;
  height: 14px;
  width: 14px;
  border-radius: 50%;
  cursor: pointer;
  background: #fff;
  margin-top: -4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-shadow: .5px .5px 2px 1px rgba(0, 0, 0, .32);
  box-shadow: .5px .5px 2px 1px rgba(0, 0, 0, .32);
  z-index: 3;
}

.map-layer-opacity-slider:focus {
  outline: none;
}

.slider-progress {
  position: absolute;
  height: 5px;
  background-color: #3498db;
  border-radius: 15px;
  top: 40%;
  left: 0.5em;
  z-index: 2;
}
</style>